import React from "react";
import { motion, Variants, AnimationDefinition } from "framer-motion";
import { PropsWithClassName, cn } from "kz-ui-sdk";

interface MegaShareCoinProps extends PropsWithClassName {
  variant: Variants;
  zIndex: number;
  onAnimationComplete?: (definition: AnimationDefinition) => void;
}

const MegaShareCoin = ({
  className,
  variant,
  zIndex,
  onAnimationComplete,
}: MegaShareCoinProps) => {
  return (
    <motion.img
      src="/images/icon-coin-2.png"
      className={cn("absolute", className)}
      style={{ zIndex }}
      variants={variant}
      onAnimationComplete={onAnimationComplete}
    />
  );
};

export default MegaShareCoin;